<template>
  <img
    class="avatar"
    :class="avatarStyleClass"
    :src="avatarUrl"
    :height="dimension"
    :width="dimension"
  />
</template>

<script>
import { avatarUrlForStyle, dimensionsForStyle } from '~/utils/avatar';

export default {
  name: 'HubAvatar',
  props: {
    userId: {
      type: Number,
      required: true,
    },
    avatarStyle: {
      type: String,
      default: 'speck',
    },
    usersAvatars: {
      type: Map,
      default: () => new Map(),
    },
  },
  data() {
    return {
      avatarUrl: null,
    };
  },
  computed: {
    allAvatars() {
      return this.$store &&
        this.$store.getters.allAvatars &&
        !Array.from(this.$store.getters.allAvatars.values()).every((x) => x === undefined)
        ? this.$store.getters.allAvatars
        : this.usersAvatars;
    },
    avatarStyleClass() {
      return 'avatar-' + this.avatarStyle;
    },
    dimension() {
      return dimensionsForStyle(this.avatarStyle);
    },
  },
  watch: {
    userId(newUserId, oldUserId) {
      if (newUserId !== oldUserId) {
        this.setAvatarUrl();
      }
    },
  },
  created() {
    this.setAvatarUrl();
  },
  methods: {
    setAvatarUrl() {
      const avatarData = this.allAvatars.get(this.userId);

      this.avatarUrl = avatarUrlForStyle(avatarData, this.avatarStyle);
    },
  },
};
</script>
